import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/Login.css';

class Login2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      message: '',
      errorMessage: '',
      successMessage: '',
      maxMessageLength: 2000, // Define the maximum message length
    };
  }

  handleInputChange = (e) => {
    const { name, value } = e.target;

    // For the message field, limit the input length
    if (name === 'message' && value.length > this.state.maxMessageLength) {
      return; // Prevent exceeding the max length
    }

    this.setState({ [name]: value });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password, message } = this.state;

    if (!(email && password && message)) {
      this.setState({ errorMessage: 'All inputs are required!' });
      return;
    }

    try {
      const response = await fetch('/login2', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email.toLowerCase(),
          password,
          message,
        }),
      });

      const data = await response.json();

      if (response.status === 200) {
        this.setState({ successMessage: 'Login successful!', errorMessage: '' });

        this.props.history.push({
          pathname: '/showtokens',
          state: { token: data.token },
        });
      } else {
        this.setState({ errorMessage: 'Invalid Credentials!', successMessage: '' });
      }
    } catch (error) {
      console.log(error);
      this.setState({ errorMessage: 'An error occurred!', successMessage: '' });
    }
  };

  render() {
    const { maxMessageLength, message, errorMessage, successMessage } = this.state;

    return (
      <div className="login-container d-flex align-items-center justify-content-center">
        <div className="text-center">
          <img className="logo" src={logo} alt="Logo" />
          <br />
          <div><Link to='/'>Home</Link></div>
          <br />
          <div>Please proceed to login...</div>
          <br />
          <div className="row justify-content-center">
            <div className="col-sm-8">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="email">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        id="email"
                        value={this.state.email}
                        onChange={this.handleInputChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="password">Password</label>
                      <input
                        type="password"
                        className="form-control"
                        name="password"
                        id="password"
                        value={this.state.password}
                        onChange={this.handleInputChange}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="message">Secret Message</label>
                      <textarea
                        className="form-control"
                        name="message"
                        id="message"
                        value={message}
                        onChange={this.handleInputChange}
                        style={{ height: '200px', width: '100%' }}
                        required
                      />
                      <small>{maxMessageLength - message.length} characters remaining</small>
                    </div>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}

                    <button type="submit" className="btn btn-dark">Login</button>
                  </form>
                  <div>Powered by</div>
                  <img className="logo2" src={logo2} alt="Logo 2" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Login2);
